module.exports = __webpack_public_path__ + "img/sh002-002.c2f47e17.jpg";